var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { FormProvider, useForm, } from "react-hook-form";
import { z } from "zod";
import { REQUIRED_MESSAGE, RequiredEmailSchema, RequiredStringSchema, RequiredPhoneSchema, } from "../../utils/schemas";
import { zodResolver } from "@hookform/resolvers/zod";
import { Stepper, TextField, useStepper } from "@opala-ds/react";
import { useMaskito } from "@maskito/react";
import { digitsOnlyMask, phoneMask } from "../../utils/masks";
import FormActions from "./FormActions";
import EducationalInstitutionCitySelect from "../Fields/EducationalInstitutionCitySelect";
import EducationalInstitutionSchoolNameSelect from "../Fields/EducationalInstitutionSchoolNameSelect";
import { useIsMobile } from "../../hooks/useIsMobile";
var Schema = z.object({
    inep: z
        .string()
        .trim()
        .nonempty(REQUIRED_MESSAGE)
        .min(8, "O código deve conter 8 dígitos"),
    nome: RequiredStringSchema,
    nome_fantasia: RequiredStringSchema,
    razao_social: RequiredStringSchema,
    email: RequiredEmailSchema,
    telefone: RequiredPhoneSchema,
    municipio: RequiredStringSchema,
});
export default function EducationalInstitutionDataForm(_a) {
    var _this = this;
    var _b, _c, _d, _e, _f, _g, _h, _j;
    var onSubmit = _a.onSubmit, _k = _a.defaultValues, defaultValues = _k === void 0 ? {
        inep: "",
        nome: "",
        nome_fantasia: "",
        razao_social: "",
        email: "",
        telefone: "",
        municipio: "",
    } : _k;
    var _l = useForm({
        defaultValues: defaultValues,
        resolver: zodResolver(Schema),
    }), watch = _l.watch, handleSubmit = _l.handleSubmit, register = _l.register, _m = _l.formState, errors = _m.errors, formStateRest = __rest(_m, ["errors"]), formRest = __rest(_l, ["watch", "handleSubmit", "register", "formState"]);
    var nextStep = useStepper().nextStep;
    var phoneMaskRef = useMaskito({ options: phoneMask });
    var inepEscolaMaskRef = useMaskito({ options: digitsOnlyMask });
    var isMobile = useIsMobile();
    return (_jsx(FormProvider, __assign({ handleSubmit: handleSubmit, register: register, watch: watch, formState: __assign({ errors: errors }, formStateRest) }, formRest, { children: _jsxs("form", __assign({ className: "w-full flex flex-col space-y-12", onSubmit: handleSubmit(function (data) { return __awaiter(_this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, onSubmit(data)];
                        case 1:
                            _a.sent();
                            nextStep();
                            return [2 /*return*/];
                    }
                });
            }); }) }, { children: [_jsxs("div", __assign({ className: "flex flex-col space-y-8 py-8" }, { children: [isMobile && (_jsx("div", __assign({ className: "flex justify-start" }, { children: _jsx(Stepper.Radial, { size: 70, weight: 5 }) }))), _jsxs("div", __assign({ className: "grid grid-cols-1 md:grid-cols-2 gap-4" }, { children: [_jsx(EducationalInstitutionCitySelect, {}), _jsx(EducationalInstitutionSchoolNameSelect, {})] })), _jsxs("div", __assign({ className: "grid grid-cols-1 md:grid-cols-2 gap-4" }, { children: [_jsx(TextField, __assign({ label: "INEP da escola", placeholder: "Digite o c\u00F3digo INEP", size: "md", helperText: (_c = (_b = errors.inep) === null || _b === void 0 ? void 0 : _b.message) !== null && _c !== void 0 ? _c : "", variant: errors.inep ? "critical" : "default", disabled: true }, register("inep"), { ref: function (node) {
                                        inepEscolaMaskRef(node);
                                        register("inep").ref(node);
                                    } })), _jsx(TextField, __assign({ label: "Raz\u00E3o social", placeholder: "Digite a raz\u00E3o social", size: "md", helperText: (_e = (_d = errors.razao_social) === null || _d === void 0 ? void 0 : _d.message) !== null && _e !== void 0 ? _e : "", variant: errors.razao_social ? "critical" : "default" }, register("razao_social")))] })), _jsxs("div", __assign({ className: "grid grid-cols-1 md:grid-cols-2 gap-4" }, { children: [_jsx(TextField, __assign({ label: "E-mail", placeholder: "Digite o seu e-mail", size: "md", helperText: (_g = (_f = errors.email) === null || _f === void 0 ? void 0 : _f.message) !== null && _g !== void 0 ? _g : "", variant: errors.email ? "critical" : "default" }, register("email"))), _jsx(TextField, __assign({ className: "w-full md:w-[232px]", label: "Telefone", placeholder: "(99) 99999-9999", size: "md", helperText: (_j = (_h = errors.telefone) === null || _h === void 0 ? void 0 : _h.message) !== null && _j !== void 0 ? _j : "", variant: errors.telefone ? "critical" : "default" }, register("telefone"), { ref: function (node) {
                                        phoneMaskRef(node);
                                        register("telefone").ref(node);
                                    } }))] }))] })), _jsx(FormActions, {})] })) })));
}
